import React, { useEffect, useState } from "react";
import "./style.css";
import {
  Layout,
  Empty,
  Breadcrumb,
  Table,
  Button,
  Space,
  Input,
  Row,
  Col,
  Divider,
  Spin,
  Tabs,
} from "antd";
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { DownloadOutlined, SyncOutlined } from "@ant-design/icons";
import Container from "../../Layout/Container";
import { Link, useHistory, useLocation } from "react-router-dom";
import { getViewAllProcess, DDsAndAdsViewProcessSelector, clearState, takeActionAsyn, takeActionChildProcessAsyn, getDcryptedPDF, EncrptyPdfDataDelAsyn } from './DDsAndAdsViewProcessSlice';
import moment from 'moment';
const { Header, Content, Footer } = Layout;
const { Search } = Input;
const { TabPane } = Tabs;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const ntop = "none";
const nbottom = "bottomCenter";



export default function ViewAllProcess() {

  const dispatch = useDispatch();
  const location = useLocation();
  let history = useHistory();
  const [isLoading, setLoading] = React.useState(false);
  const [isToast, setToast] = React.useState(false);
  const [processRecord, setprocessRecord] = useState([]);
  const [dnlodBtnDisable, setdnlodBtnDisable] = useState(false);

  const { isFetching, isAllprocessSuccess, isError, errorMessage, allProcessData, concurrentDoc, processTimeLogs, signed, docPathname } = useSelector(
    DDsAndAdsViewProcessSelector
  );


  useEffect(() => {
    setLoading(true);
    setToast(false);
    dispatch(clearState());
    dispatch(getViewAllProcess(location.state.processName));
  }, []);

  useEffect(() => {

    if (isError) {
      setprocessRecord([]);
      setLoading(false);
      setToast(true);
      toast.error(errorMessage);
      dispatch(clearState());
    }
    if (isAllprocessSuccess) {
      setLoading(false);
      setprocessRecord(allProcessData);
    }

  }, [isError, isAllprocessSuccess, setLoading, allProcessData, processTimeLogs, concurrentDoc, signed, docPathname]);


  const data = [
    {
      id: 1,
      process_action: "Process Initiated",
      action_taken_by: "Homer Ryan",
      type: "Clerk",
      date_time: "11 Jun 2021, 11:43PM",
      doc_changes: "Uploaded",
      comments: "No",
    }
  ];

  const renderContent = (value, row, index) => {
    const obj = {
      children: value,
      props: {},
    };
    return obj;
  };

  const columns = [
    {
      title: "Process Action",
      dataIndex: "process_action",
      render: renderContent,
    },
    {
      title: "Action Taken by",
      dataIndex: "action_taken_by",
      render: renderContent,
    },
    {
      title: "Type",
      dataIndex: "type",
      render: renderContent,
    },
    {
      title: "Date & Time",
      dataIndex: "date_time",
      render: renderContent,
    },
    {
      title: "Doc Changes",
      dataIndex: "dwnFile",
      render: (text, row, index) => {
        return {
          children: <p className="mar-b-0 process-time-log-docs"><span>{row.doc_changes}</span>
            {/* <Link to={row.dwnFile} target="_blank" download><DownloadOutlined /></Link> */}
            {row.doc_changes != "No"
              && <Button type="link" onClick={() => handleEncrpDnldLink(row)} title={dnlodBtnDisable ? 'Please wait..' : null} disabled={dnlodBtnDisable} style={{ color: 'rgb(37, 55, 217)', fontSize: 18, margin: '0px', padding: '0px', border: 'none', background: 'transparent' }} className="mar-l-0"><DownloadOutlined className="custom-change-cursor" /></Button>

            }
          </p>,
          props: {
            //colSpan: 5,
          },
        };
      },
    },
    {
      title: "Comments",
      dataIndex: "comments",
      render: renderContent,
    },
  ];

  const columnsForConcurentlog = [
    {
      title: "Process Id",
      dataIndex: "process_id",
      render: renderContent,
    },
    {
      title: "Status",
      dataIndex: "p_status",
      render: renderContent,
    },
    {
      title: "File",
      dataIndex: "dwnFile",
      render: (text, row, index) => {
        return {
          children: <p className="mar-b-0 process-time-log-doc">
            {/* <span>File</span> */}
            {/* <Link to={row.dwnFile} target="_blank" download><DownloadOutlined /></Link> */}
            {row.p_status != "No"
              && <Button type="link" onClick={() => handleEncrpDnldLink(row)} title={dnlodBtnDisable ? 'Please wait..' : null} disabled={dnlodBtnDisable} style={{ color: 'rgb(37, 55, 217)', fontSize: 18, margin: '0px', padding: '0px', border: 'none', background: 'transparent' }} className="mar-l-0"><DownloadOutlined className="custom-change-cursor" /></Button>

            }
          </p>,
          props: {
            //colSpan: 5,
          },
        };
      },
    },
  ];


  const handleEncrpDnldLink = async (record) => {

    setdnlodBtnDisable(true);
    let waitForDcrpt = await dispatch(getDcryptedPDF(record.dwnFile)).then((pdf_Data) => {
      setTimeout(function () {
        var link = document.createElement("a");
        link.setAttribute('href', `${process.env.REACT_APP_SERVER_PDF_ENC_URL}/document/${record.dwnFile}.enc.unenc`)
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(link);
      }, 2000);
      setTimeout(async function () {
        let a = await dispatch(EncrptyPdfDataDelAsyn(record.dwnFile))
        setdnlodBtnDisable(false);
      }, 4000);


    });

  }


  const handleViewDocumentSeenStamp = (row,y,u,v,w,x) => {
    // console.log("click kk", `${y} ${u} ${v} ${w} ${x}`);
     if (row.processId) {
   
       if (row.parentProcessId != null) {
   
         let takeActionChildProcess = dispatch(takeActionChildProcessAsyn(row.processId)).then((res) => {
   
           history.push({
             pathname: '/verify-document2',
             state: { documentInfo: res.data, 
               processId: row.processId,
          
                
               
               
               }
           });
   
         });
       }
       else {
   
         let takeAction = dispatch(takeActionAsyn(row.processId)).then((res) => {
           // console.log('res', res)
           history.push({
             pathname: '/verify-document2',
             state: { documentInfo: res.data,
                processId: row.processId,
                 viewDocument: true,
                  mystorepage:y,
                 
                  backsearch:u,
                  option:v,
                  header:w,
                  count:x, }
           });
         });
       }
     }
   
     }


  const handleStatusApprovedDelay = (record) => {

    var status = "";
    var msg = "";

    if (record && record.isSigned === true) {
      status = "text-color-success mar-t-15 seen-stamp-signed-stage";
      msg = "Signed";
    }
    // else {
    //   status = "text-color-danger mar-t-15 seen-stamp-not-signed-stage";
    //   msg = "Not signed"
    // }


    var result = {
      status: status,
      msg: msg,
    };

    return result;

  }


  let dataSource = isLoading
    ? []
    : processTimeLogs && processTimeLogs.length > 0 ? processTimeLogs.map(row => ({
      id: row._id,
      process_action: row.processAction,
      action_taken_by: row.actionTokenBy,
      type: row.type,
      date_time: moment(row.addedOn).format("lll"),
      doc_changes: row.isStatus,
      // dwnFile: docPathname + row.pdfFile,
      dwnFile: row.pdfFile,
      comments: row && row.isComment && row.isComment === true ? "Yes" : "No",
    })) : [];


  let dataSource2 = isLoading
    ? []
    : concurrentDoc && concurrentDoc.length > 0 ? concurrentDoc.map(row => ({
      id: row._id,
      process_id: row.processId,
      p_status: row.status,
      // con_dwnFile: docPathname + row.concurrentPdfFile,
      dwnFile: row.concurrentPdfFile,

    })) : [];


    const handleBack = (e,y,z,t) => {
      //  console.log("click", row, "e", e);   
      history.push({
        pathname: '/all-process',
        state: {dynamicPage:y,backsearch:z,option:t}
      });
  
    }

  return (
    <>
      <Container>
        <Breadcrumb style={{ backgroundColor: '#f3f8ff', padding: '26px 50px' }} separator=">">
          <Breadcrumb.Item><Link to="/all-process">All Process</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Recuritment Request</Breadcrumb.Item>
        </Breadcrumb>
        <div
          className="site-layout-content"
          style={{ paddingTop: 0 }}
        >
          <div>
            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
            {isToast &&
              <Toaster
                toastOptions={{
                  className: '',
                  style: {
                    border: '1px solid #713200',
                    padding: '16px',
                    color: '#713200',
                    marginTop: 50
                  },
                }}
              >
                {(t) => (
                  <ToastBar toast={t}>
                    {({ icon, message }) => (
                      <>
                        {icon}
                        {message}
                        {t.type !== 'loading' && (
                          <button onClick={() => toast.dismiss(t.id)}>X</button>
                        )}
                      </>
                    )}
                  </ToastBar>
                )}
              </Toaster>
            }

            <Space
              style={{
                // padding: 16,
                width: "100%",
                // borderLeft: "1px solid #dfe0eb",
                // borderRight: "1px solid #dfe0eb",
              }}
              size="large"
            >
              <Row style={{ width: "100%" }}>
                <Col span="8" className="bg-fbfbfb pad-40" style={{ borderRight: 'solid 2px #f1f1f1', backgroundColor: '#e8f0f8' }}>
                  <h1 className="mar-b-30" style={{ fontWeight: "600", color: "#292c40", fontSize: "23px" }}>
                    <img src="./images/pdficon.png" style={{ width: "45px" }} />
                    &nbsp; Recuritment Request
                  </h1>
                  <Row>
                    <Col span="12">
                      <p className="text-color-6b778c mar-b-5">Process ID</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.processId ? processRecord.processId : 'N/A'}</p>

                      <p className="text-color-6b778c mar-b-5">Download Restricted</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.restrictDownload && processRecord.restrictDownload === true ? "Yes" : "No"}</p>

                      <p className="text-color-6b778c mar-b-5">Times Document Signed</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.signCount || processRecord.signCount === 0 ? processRecord.signCount : "N/A"}</p>
                    </Col>
                    <Col span="12" className="text-right">
                      <p className="text-color-6b778c mar-b-5">Added On</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.addedOn ? moment(processRecord.addedOn).format("ll") : "N/A"}</p>

                      <p className="text-color-6b778c mar-b-5">Document Type</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.documentType ? processRecord.documentType : "N/A"}</p>

                      <p className="text-color-6b778c mar-b-5">Recived From</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.receivedFrom ? processRecord.receivedFrom : "N/A"}</p>
                    </Col>
                  </Row>

                  <Row>

                    <Col span="23">
                      <p className="text-color-6b778c mar-b-5">Subject</p>
                      <p className="font-16 mar-b-25">{processRecord && processRecord.processSubject ? processRecord.processSubject : "N/A"}</p>

                    </Col>
                    <Col span="1"></Col>
                  </Row>

                </Col>
                <Col span="16" className="bg-fbfbfb pad-40 #f1f1f1">

                  <Row>
                    <Col className="mar-b-25" span="12" style={{ textAlign: "Left" }}>
                      <h1 className="font-24" style={{ fontWeight: "600", color: "#292c40" }}>Process Flow</h1>
                    </Col>
                    <Col span="12" style={{ textAlign: "right" }}>
                    <Space>
                        <Button
                          size="large"
                          style={{
                            borderRadius: 5,
                            padding: "3px 8px",
                            fontWeight: 600,
                            fontSize: 14,
                            height: '35px',
                          }}
                          onClick={(e) => handleViewDocumentSeenStamp(
                            processRecord,
                            location.state.mystorepage,
                            location.state.mysearch,
                            location.state.myOption,
                            location.state.myheader,
                            location.state.mycount
                            )}
                          type="primary"
                        >
                          View Document
                        </Button>
                      </Space>
                      <Space>
                        <Button
                          size="small"
                          style={{
                            marginLeft:'5px',
                            borderRadius: 5,
                            padding: "3px 8px",
                            fontWeight: 600,
                            fontSize: 14,
                            height: '35px',
                          }}
                          onClick={(e) => handleBack(e,location.state.mystorepage,location.state.mysearch, location.state.myOption)}
                        
                          type="secondary"
                        ghost>
                          &#8647; Back To Last Process Pg
                        </Button>
                      </Space>
                    </Col>
                  </Row>

                  {signed && signed.length > 0 ?

                    signed.map(function (row, item) {
                      // var str = 'Bob,1234,Bob@example.com;Mark,5678,Mark@example.com',
                      var timeArray = row && row.isSigned === true && row.signWithin && row.signWithin.time.split(':').map(a => a.split(','));

                      return (
                        <>
                          <div className="mar-b-30" key={item}>
                            <h5 style={{ color: "#000000", fontWeight: "500" }} className="font-16 mar-b-10">Stage {row && row.stage}</h5>
                            <Space
                              style={{
                                padding: 16,
                                width: "100%",
                                backgroundColor: "#e8f0f8"
                              }}
                              size="large"
                            >
                              <Row>
                                {/* <Col span="6">

                                  <p className="text-color-6b778c mar-b-5">Respond Within</p>
                                  <p className="font-16 mar-b-0">{row && row.isSigned === true && row.signWithin ? row.signWithin.day + " day " + timeArray[0] + " Hours " + timeArray[1] + " Minutes " + timeArray[2] + " Second " : "N/A"}</p>

                                </Col> */}
                                <Col span="8">

                                  <p className="text-color-6b778c mar-b-5">Approved by</p>
                                  <p className="font-16 mar-b-0 single-line-text-dot" style={{ paddingRight: "15px" }}>{row && row.detailedUser && row.detailedUser.fullName ? row.detailedUser.fullName : "N/A"}</p>
                                </Col>
                                <Col span="8">

                                  <p className="text-color-6b778c mar-b-5">Approved on</p>
                                  <p className="font-16 mar-b-0">{row && row.responseTime != null ? moment(row.responseTime).format("ll") : "N/A"}</p>
                                </Col>
                                <Col span="8">
                                  <p className={handleStatusApprovedDelay(row).status}>{handleStatusApprovedDelay(row).msg}</p>
                                  {/* <p className="text-color-danger mar-t-15 font-17">Delayed by 2 hours</p> */}
                                </Col>
                              </Row>

                            </Space>
                          </div>
                        </>
                      );
                    })
                    :
                    (
                      <div className="mar-b-30">
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                      </div>
                    )

                  }


                  <h1
                    style={{
                      fontStyle: "normal",
                      fontWeight: "600",
                      fontSize: 22,
                      color: "#292c40",
                      marginBottom: 12,
                      marginTop: 15,
                    }}
                  >
                    Process Time Log
                  </h1>
                  <Table
                    columns={columns}
                    pagination={false}
                    // pagination={{
                    //   position: [ntop, nbottom],
                    //   size: "small",
                    //   defaultPageSize: 8,
                    //   hideOnSinglePage: true,
                    // }}
                    dataSource={dataSource}
                    bordered

                    className="mytablecss table-seen-stamp-time-log"
                  />


                  {concurrentDoc && concurrentDoc.length > 0 ? <>
                    <h1
                      style={{
                        fontStyle: "normal",
                        fontWeight: "600",
                        fontSize: 22,
                        color: "#292c40",
                        marginBottom: 12,
                        marginTop: 20,
                      }}
                    >
                      Concurrent Process Log
                    </h1>
                    <Table
                      columns={columnsForConcurentlog}
                      pagination={false}
                      // pagination={{
                      //   position: [ntop, nbottom],
                      //   size: "small",
                      //   defaultPageSize: 8,
                      //   hideOnSinglePage: true,
                      // }}
                      dataSource={dataSource2}
                      bordered

                      className="mytablecss table-seen-stamp-time-log"
                    />
                  </>
                    :
                    <></>
                  }


                </Col>
              </Row>
            </Space>

          </div>
        </div>
      </Container>
    </>
  );
}
